// Module
var code = "<div class=\"iia-regional-message\"></div>";
// Exports
module.exports = code;